import * as React from "react";
const SvgOk = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.8002 16.2L4.6002 12L3.2002 13.4L8.8002 19L20.8002 6.99998L19.4002 5.59998L8.8002 16.2Z", fill: "#288626" }));
export default SvgOk;
